import React from 'react';
import { Link } from 'gatsby';
import { useTranslation } from 'react-i18next';
import LibraryItemTile from '@/components/library-elements/library-item-tile';
import LibraryVerticalScrollbar from '@/components/library-elements/library-vertical-scrollbar';
import SparkleIcon from '@/images/icon-oth-sparkle.svg';
import { LibraryPages, getLibraryUrlPrefix } from '@/utils/url';

export default function LibraryIndex({ locale, tools = [], lessons = [] }) {
	const { t } = useTranslation();

	const toolsUrl = `/${getLibraryUrlPrefix(locale, t, LibraryPages.ALL_TOOLS)}`;
	const lessonsUrl = `/${getLibraryUrlPrefix(locale, t, LibraryPages.ALL_LESSONS)}`;

	return (
		<div className="container pb-10">
			{tools.length > 0 && (
				<div>
					<div className="prose pb-2">
						<h1>
							<Link to={toolsUrl} className="no-underline hover:underline text-inherit">
								{t('gynzy-library.tools')}
							</Link>
						</h1>
					</div>
					<div>
						<LibraryVerticalScrollbar>
							{tools.map(tool => (
								<LibraryItemTile key={tool.id} locale={locale} item={tool} lazyImg={false} />
							))}
						</LibraryVerticalScrollbar>
					</div>
					<div className="flex justify-end items-center pr-16 text-mariner hover:text-mariner-light active:text-mariner-dark fond-semibold underline">
						<SparkleIcon className="h-6 w-6" />
						<Link to={toolsUrl} className="pl-2">
							{t('gynzy-library.discover-more')}
						</Link>
					</div>
				</div>
			)}
			{lessons.length > 0 && (
				<div className="pt-6">
					<div className="prose pb-2">
						<h1>
							<Link to={lessonsUrl} className="no-underline hover:underline text-inherit">
								{t('gynzy-library.lessons')}
							</Link>
						</h1>
					</div>
					<div>
						<LibraryVerticalScrollbar>
							{lessons.map(lesson => (
								<LibraryItemTile key={lesson.id} locale={locale} item={lesson} />
							))}
						</LibraryVerticalScrollbar>
					</div>
					<div className="flex justify-end items-center pr-16 text-mariner hover:text-mariner-light active:text-mariner-dark fond-semibold underline">
						<SparkleIcon className="h-6 w-6" />
						<Link to={lessonsUrl} className="pl-2">
							{t('gynzy-library.discover-more')}
						</Link>
					</div>
				</div>
			)}
		</div>
	);
}
